module.exports = __webpack_public_path__ + "static/media/a.96925796.png";